import { showFailToast } from 'vant'

// 处理服务器异常，弹出消息
function verifyServiceCode(code, successCB, errorMes) {
  if (code === 200) {
    successCB()
    return
  }
  showFailToast(errorMes)
}

// 生成数组
const localEnumeratedLibrary = (minVal, len) => {
  return Object.keys(new Array(len).fill('')).map((item) => Number(item) + minVal)
}

// 格式化时间到分钟
function formatDateToMinute(time) {
  const date = new Date(time)
  var year = date.getFullYear()
  var month = ('0' + (date.getMonth() + 1)).slice(-2) // Months are zero based, add leading 0
  var day = ('0' + date.getDate()).slice(-2) // Add leading 0
  var hour = ('0' + date.getHours()).slice(-2) // Add leading 0
  var minute = ('0' + date.getMinutes()).slice(-2) // Add leading 0

  return year + '-' + month + '-' + day + ' ' + hour + ':' + minute
}

// 验证密码强度
// 密码强度要求：8-20位包含数字、大小写字母和特殊字符的密码，至少包含其中3种，特殊字符仅限 ~!@#$%^&*()_+！￥…（）-—= ·`
const myValidatePassword = (password) => {
  if (!/^[\s\S]{8,20}$/.test(password)) return false

  let types = 0
  if (/[0-9]/.test(password)) types++
  if (/[a-z]/.test(password)) types++
  if (/[A-Z]/.test(password)) types++
  // 只允许指定的特殊字符
  if (/[~!@#$%^&*()_+！￥…（）\-—= ·`]/.test(password)) types++

  // 检查是否包含不允许的特殊字符
  if (/[^0-9a-zA-Z~!@#$%^&*()_+！￥…（）\-—= ·`]/.test(password)) return false

  return types >= 3
}

/**
 * 校验密码复杂度
 * 规则：
 * 1. 长度为 8-20 个字符；
 * 2. 必须包含数字、小写字母、大写字母、指定特殊字符中的至少三种；
 * 3. 特殊字符仅限：~!@#$%^&*()_+！￥…（）—= ·`
 * 4. 不允许出现其他非法字符，若有非法字符，需提示出来
 */

/**
 * 用于转义正则特殊字符
 * @param {string} str
 * @returns {string}
 */
function escapeRegExp(str) {
  return str.replace(/[-[\]{}()*+?.\\^$|]/g, '\\$&')
}

/**
 * 判断包含的字符种类数量（数字、小写、大写、特殊）
 * @param {string} value
 * @param {RegExp} specialCharRegex
 * @returns {number}
 */
function countCharacterTypes(value, specialCharRegex) {
  let types = 0
  if (/\d/.test(value)) types++ // 数字
  if (/[a-z]/.test(value)) types++ // 小写字母
  if (/[A-Z]/.test(value)) types++ // 大写字母
  if (specialCharRegex.test(value)) types++ // 合法特殊字符
  return types
}

/**
 * 密码校验函数，用于 async-validator
 * @param {*} rule
 * @param {string} value
 * @param {Function} callback
 */
function validatePassword(rule, value, callback) {
  if (!value) {
    callback()
    return
  }

  if (value.length < 8 || value.length > 20) {
    callback(new Error('密码长度需在8-20位之间'))
    return
  }

  // 允许的特殊字符
  const allowedSpecialChars = `~!@#$%^&*()_+！￥…（）—=·\``

  // 转义后构建安全字符集，注意 `-` 不能出现在字符集中间
  const escaped = escapeRegExp(allowedSpecialChars).replace(/-/g, '')
  const safeCharClass = `${escaped}-` // 把 - 放末尾

  const specialCharRegex = new RegExp(`[${safeCharClass}]`)
  const illegalCharRegex = new RegExp(`[^a-zA-Z0-9${safeCharClass}]`, 'g')

  // 检查非法字符
  const illegalChars = value.match(illegalCharRegex)
  if (illegalChars) {
    const uniqueIllegalChars = [...new Set(illegalChars)].map((char) => (char === ' ' ? '空格' : char)).join(' ')
    callback(new Error(`不得包含非法字符：${uniqueIllegalChars}`))
    return
  }

  // 校验类型数量
  const types = countCharacterTypes(value, specialCharRegex)
  if (types < 3) {
    callback(new Error('密码需包含数字、大小写字母、特殊字符中的至少三种'))
    return
  }

  callback()
}

export { verifyServiceCode, localEnumeratedLibrary, formatDateToMinute, myValidatePassword, validatePassword }
